import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useUserTags, getTagColorClass } from "@/hooks/useUserTags";
import { Badge } from "@/components/ui/badge";

interface RequiredTagsSelectProps {
  value: string[];
  onChange: (tags: string[]) => void;
}

const RequiredTagsSelect = ({ value, onChange }: RequiredTagsSelectProps) => {
  const { allTags, isLoadingTags } = useUserTags();

  const handleToggle = (tagName: string) => {
    if (value.includes(tagName)) {
      onChange(value.filter(t => t !== tagName));
    } else {
      onChange([...value, tagName]);
    }
  };

  return (
    <div className="space-y-2">
      <Label>Restrict Booking by Status</Label>
      <p className="text-sm text-muted-foreground">
        Only users with at least one of these statuses can book. Leave empty for no restrictions.
      </p>
      
      {isLoadingTags ? (
        <p className="text-sm text-muted-foreground">Loading tags...</p>
      ) : (
        <div className="grid grid-cols-2 gap-2 mt-2 max-h-48 overflow-y-auto border rounded-md p-3">
          {allTags.map((tag) => (
            <div key={tag.id} className="flex items-center space-x-2">
              <Checkbox
                id={`tag-${tag.id}`}
                checked={value.includes(tag.name)}
                onCheckedChange={() => handleToggle(tag.name)}
              />
              <label
                htmlFor={`tag-${tag.id}`}
                className="text-sm cursor-pointer flex items-center gap-1"
              >
                <Badge 
                  variant="outline" 
                  className={`text-xs ${getTagColorClass(tag.color)}`}
                >
                  {tag.name}
                </Badge>
              </label>
            </div>
          ))}
          {allTags.length === 0 && (
            <p className="text-sm text-muted-foreground col-span-2">No tags available</p>
          )}
        </div>
      )}
    </div>
  );
};

export default RequiredTagsSelect;
